/*
  Collection infinite scroll (web_dev, 2026-10-20).
  - The next page is worked out from the page itself: .pagination-wrapper[data-page] gives the
    page shown, and a pagination link to page+1 means there is a next page.
  - When the grid is replaced (filter, sort, back/forward), the state starts over from the new grid.
  - A response that arrives after the grid was replaced is thrown away.
  - Stops cleanly at the last page; a failed request can be retried by scrolling again (max 3).
  Appends items matching ITEM_SELECTOR (cards carry .scroll-trigger because the theme setting
  "reveal on scroll" is on). Collection tiles are re-inserted by snippets/collection-banners.liquid.
*/
document.addEventListener('DOMContentLoaded', function () {
  const GRID_SELECTOR = '#product-grid';
  const ITEM_SELECTOR = '.product.grid__item.scroll-trigger';
  const MAX_FAILURES = 3;

  const state = { grid: null, page: 1, hasNext: false, loading: false, failures: 0, token: 0 };

  function pageOf(root) {
    const wrap = root.querySelector('.pagination-wrapper[data-page]');
    const n = wrap ? parseInt(wrap.getAttribute('data-page'), 10) : NaN;
    return n > 0 ? n : 1;
  }

  function hasPage(root, n) {
    const links = root.querySelectorAll('.pagination a[href]');
    for (const a of links) {
      try {
        if (new URL(a.getAttribute('href'), window.location.origin).searchParams.get('page') === String(n)) return true;
      } catch (e) {}
    }
    return false;
  }

  function syncWithGrid() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (grid === state.grid) return grid;
    state.grid = grid;
    state.token++;
    state.loading = false;
    state.failures = 0;
    hideSpinner();
    if (!grid) { state.hasNext = false; return null; }
    const container = grid.closest('#ProductGridContainer') || document;
    state.page = pageOf(container);
    state.hasNext = hasPage(container, state.page + 1);
    return grid;
  }

  function loadNextPage() {
    if (state.loading || !state.hasNext || state.failures >= MAX_FAILURES) return;
    const token = state.token;
    const nextPage = state.page + 1;
    state.loading = true;
    showSpinner();

    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (token !== state.token) return; // grid was replaced while loading
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(ITEM_SELECTOR);
        newItems.forEach(function (item) { state.grid.appendChild(item); });
        state.page = nextPage;
        state.hasNext = newItems.length > 0 && hasPage(doc, nextPage + 1);
        state.failures = 0;
      })
      .catch(function () {
        if (token === state.token) state.failures++;
      })
      .finally(function () {
        if (token !== state.token) return;
        state.loading = false;
        hideSpinner();
      });
  }

  function scrollHandler() {
    const grid = syncWithGrid();
    if (!grid || !state.hasNext) return;
    if (grid.getBoundingClientRect().bottom <= window.innerHeight * 0.85) loadNextPage();
  }

  function showSpinner() {
    const spinner = document.getElementById('infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'block';
  }

  function hideSpinner() {
    const spinner = document.getElementById('infinite-scroll-spinner');
    if (spinner) spinner.style.display = 'none';
  }

  syncWithGrid();
  window.addEventListener('scroll', scrollHandler, { passive: true });
});
